<template>
  <container id='gift' num='02' title='蟹券/礼盒'>
    <lazy-image :class='$style.img' :src='require("../assets/xiequan-mobile.jpg")' mobile />
    <lazy-image :class='$style.img' :src='require("../assets/xiequan.jpg")' pc />
  </container>
</template>

<script>
import Container from "./Container";
export default {
  name: "Gift",
  components: { Container }
};
</script>

<style lang='scss' module>
@import "../tool";
@media screen and (max-width: 750px) {
  .img[mobile] {
    display: block !important;
  }
  .img[pc] {
    display: none !important;
  }
}
.img {
  width: 100%;
}
.img[mobile] {
  display: none;
}
</style>